import { render, staticRenderFns } from "./BannerInterno.vue?vue&type=template&id=2d4bb252&lang=pug&"
import script from "./BannerInterno.vue?vue&type=script&lang=js&"
export * from "./BannerInterno.vue?vue&type=script&lang=js&"
import style0 from "./BannerInterno.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports